


































import { Component, Vue, Prop } from "vue-property-decorator";
import { TopDataItem } from "@/classes/DistroDataSet";

@Component
export default class TopWidget extends Vue {
  @Prop() topData!: TopDataItem[];
  @Prop() title!: string;
  @Prop() nameLabel!: string;
  @Prop() valueLabel!: string;
  @Prop() valueType!: "number" | "currency";
  @Prop() linkTo?: string;

  private formatValue(value: number): string {
    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD"
    });

    if (this.$props.valueType === "currency") {
      return formatter.format(value);
    } else {
      return value.toString();
    }
  }
}
